<template>
  <section id="financial-performance" class="o-section c-financial" v-my-section-class>

    <!-- Background -->
    <div class="o-background" v-if="$store.state.device !== 0">
      <div class="o-background__inner">
        <div class="o-background__group o-background__group--turq" key="turq" v-if="tabIndex === 0">
          <my-circle class="o-background__item o-background__item--1" :variant="2"></my-circle>
        </div>
        <div class="o-background__group o-background__group--orange" key="orange" v-if="tabIndex === 1">
          <my-circle class="o-background__item o-background__item--1" :variant="2"></my-circle>
        </div>
        <div class="o-background__group o-background__group--purple" key="purple" v-if="tabIndex === 2">
          <my-circle class="o-background__item o-background__item--1" :variant="2"></my-circle>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="o-section__container">
      <h2 class="o-section__title">Our financial performance</h2>

      <my-tabs @tab-changed="setTabIndex">

        <!-- Tab 1 -->
        <my-tab title="East" :is-active="true" tab-color="turq">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">Eastern Power Networks plc</h3>
              <p class="o-panel__subtitle">Serving North London and East Anglia</p>
            </div>
            <div class="o-panel__body">
              <my-table :table-data="regions[0]"></my-table>
              <p class="u-footnote">{{ footnote }}</p>
            </div>
            <div class="o-link__btn-group">
              <my-download-button :section="'financial-performance'"></my-download-button>
            </div>
          </my-tab-inner>
        </my-tab>

        <!-- Tab 2 -->
        <my-tab title="London" tab-color="orange">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">London Power Networks plc</h3>
              <p class="o-panel__subtitle">Serving Inner London</p>
            </div>
            <div class="o-panel__body">
              <my-table :table-data="regions[1]"></my-table>
              <p class="u-footnote">{{ footnote }}</p>
            </div>
            <div class="o-link__btn-group">
              <my-download-button :section="'financial-performance'"></my-download-button>
            </div>
          </my-tab-inner>
        </my-tab>

        <!-- Tab 3 -->
        <my-tab title="South East" tab-color="purple">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">South Eastern Power Networks plc</h3>
              <p class="o-panel__subtitle">Serving South London, Kent, East Sussex and parts of Surrey and West Sussex</p>
            </div>
            <div class="o-panel__body">
              <my-table :table-data="regions[2]"></my-table>
              <p class="u-footnote">{{ footnote }}</p>
            </div>
            <div class="o-link__btn-group">
              <my-download-button :section="'financial-performance'"></my-download-button>
            </div>
          </my-tab-inner>
        </my-tab>
      </my-tabs>
    </div>
  </section>
</template>

<script>
import { MySectionClass } from '@/directives/my-section-class.js'
import { MyTabs, MyTab, MyTabInner } from '@/components/standard/my-tabs'
import MyTable from '@/components/standard/my-table'
import MyCircle from '@/components/standard/my-circle'
import MyDownloadButton from '@/components/standard/my-download-button'
import mixins from '@/mixins'

export default {
  name: 'my-financial',
  components: {
    MyTabs,
    MyTab,
    MyTabInner,
    MyCircle,
    MyTable,
    MyDownloadButton
  },
  directives: {
    MySectionClass
  },
  mixins: [mixins],
  data () {
    return {
      regions: ['East', 'London', 'South East'],
      regionSlugs: ['east', 'london', 'south-east'],
      footnote: '* Financial information for 2016/17 is presented under the new UK accounting standard FRS 102 and the comparatives in 2015/16 have been restated to be on a consistent basis.'
    }
  },
  methods: {
    initData () {
      this.regions.forEach((d, i, a) => {
        let regionSlug = this.regionSlugs[i]
        let data = require('@/assets/data/financial-' + regionSlug + '.csv')

        a[i] = {
          title: d,
          slug: regionSlug,
          data: data
        }
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// MyFinancial.vue?6ea0889c